export const NOT_DOT = /-|\s/;
export const BRACE_START = "[\"";
export const BRACE_END = "\"]";
